import {
    ApolloClient,
    NormalizedCacheObject,
} from '@apollo/client'
import { CachePersistor } from 'apollo-cache-persist'
import { GetProjectElementNodesQuery } from 'api/graphQL/queries/projectElements.queries'
import { getLocalStorageKeyValueSize } from '@deltek/specification-client/core/Utilities/localstorageUtils'
import { ApolloCacheKey } from '@deltek/specification-client/core/Configurations/apolloBaseClient'

export const cacheWatcher = (client: ApolloClient<NormalizedCacheObject>, persistor: CachePersistor<unknown>) => {
    const maxCacheSize = 4 // in MB

    // watcher for GetProjectElementNodesQuery
    // added watcher only for GetProjectElementNodesQuery as it is one of the largest query in the application
    client.cache.watch({
        query: GetProjectElementNodesQuery,
        optimistic: true,
        callback: async () => {
            const size = getLocalStorageKeyValueSize(ApolloCacheKey)
            if (size >= maxCacheSize) {
                await persistor.purge()
                await client.cache.reset()
            }

        },
    });

}